import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CsvExportParams, GridApi } from 'ag-grid-community';

import { FiltersService } from '../../services/filters.service';
import { GridService } from '../../services/grid-defs.service';
import { CheckboxFilterComponent } from '../checkbox-filter/checkbox-filter.component';
import { InputColumnFilterComponent } from '../input-column-filter/input-column-filter.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-grid-list',
  templateUrl: './grid-list.component.html',
  styleUrls: ['./grid-list.component.scss']
})

export class GridListComponent implements OnInit {

  @Input() rowData: any;
  @Input() paginationAutoPageSize: any;
  @Input() suppressRowClickSelection: any;
  @Input() pagination: any;
  @Input() type: string;
  @Input() downloadParams: CsvExportParams;

  @Output() numberOfSelectedRows = new EventEmitter<number>();

  form: FormGroup;
  defaultColDef = { sortable: true };
  selectedRows = 0;
  objectDefs: any;
  gridApi: GridApi;
  columnApi: any;
  columnFilter = [];

  filterGroup = {
    certificates: {
      checkboxFilterComponent: CheckboxFilterComponent,
      inputColumnFilterComponent: InputColumnFilterComponent
    },
    users: {
      checkboxFilterComponent: CheckboxFilterComponent,
      inputColumnFilterComponent: InputColumnFilterComponent
    }
  };

  constructor(
    private router: Router,
    public filtersService: FiltersService,
    public gridService: GridService,
    private formBuilder: FormBuilder,
    private translate: TranslateService
  ) {
    this.filtersService.fitFilters().subscribe(data => {
      // console.log(data);
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      orders: new FormArray([])
    });
    this.columnFilter = this.gridService[this.type].map(col => {
      return {
        headerName: col.headerName,
        value: col.field,
        checked: col.field === 'id' ? false : true
      };
    });
    this.addCheckboxes();
  }

  addCheckboxes() {
    this.columnFilter.forEach(column => {
      const control = new FormControl(column.checked);
      (this.form.controls.orders as FormArray).push(control);
    });
  }

  onClickRequest(row) {
    const id = row.data.id;
    this.router.navigate(['home/' + this.type, id]);
  }

  onRowSelected(event) {
    if (event.node.selected) {
      this.selectedRows++;
    } else {
      this.selectedRows--;
    }
    this.numberOfSelectedRows.emit(this.selectedRows);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    window.addEventListener('resize', () => {
      setTimeout(() => params.api.sizeColumnsToFit());
    });
  }

  onBtExport() {
    this.gridApi.exportDataAsCsv(this.downloadParams);
  }

  onRowClicked(row: any) {
    const id = row.data.id;
    this.router.navigate(['home/' + this.type, id]);
  }

}
